import PublicApiModel from './globals/PublicApiModel';

export default class ResetPasswordTokenModel extends PublicApiModel {
  static get path() {
    return '/backend/users/reset-password/token';
  }
}
